<template>
  <div>
    <base-header
        class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center bg-gradient-primary"
        style="
        min-height: 200px;
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-blue opacity-8"></span>
      <!-- Header container -->
      <div class="">
        <div class="row">
          <div class="">
            <h3 class="text-white float-start pe-3 text-uppercase fw-bold">
              {{ requestData.serviceType }} {{ requestData.refNumber }}
</h3>
<!--            <div class="badge p-1 font-size-xs float-start" :class="getStatusClass(requestData.status)">-->
<!--              <span class="status">{{ requestData.status }}</span>-->
<!--            </div>-->
            <br>
          </div>
<!--          <div class="col-12 text-start">-->
<!--            <h3 class="text-white float-start pe-3">-->
<!--              <span v-if="requestData.hasOwnProperty('mStartDate')">{{ requestData.mStartDate.format("dddd, DD MMM YYYY") }}</span>-->
<!--              <br><span v-if="requestData.hasOwnProperty('mEndDate')">{{ requestData.mStartDate.format("HH:mm") }} - {{ requestData.mEndDate.format("HH:mm") }}</span>-->
<!--            </h3>-->
<!--          </div>-->
          <!--            <p class="text-white mt-0 mb-5">-->
          <!--              This is your profile page. You can see the progress you've made-->
          <!--              with your work and manage your projects or assigned tasks-->
          <!--            </p>-->
          <!--            <a href="#!" class="btn btn-info">Edit profile</a>-->
</div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <!--      <div class="text-start p-2 ps-0">-->
      <!--        <div class="btn-group me-2" role="group" aria-label="First group">-->
      <!--          <router-link :to="'/requests/'+$route.params.id+'/info'" class="btn btn-secondary mt-1 mb-1">-->
      <!--            <span class="nav-link-text">{{ $t("Info") }}</span>-->
      <!--          </router-link>-->
      <!--          <router-link :to="'/requests/'+$route.params.id+'/documents'" class="btn btn-secondary mt-1 mb-1">-->
      <!--            <span class="nav-link-text">{{ $t("Documents") }}</span>-->
      <!--          </router-link>-->
      <!--          <router-link :to="'/requests/'+$route.params.id+'/paymentDetails'" class="btn btn-secondary mt-1 mb-1">-->
      <!--            <span class="nav-link-text">{{ $t("Payment Details") }}</span>-->
      <!--          </router-link>-->
      <!--          <router-link :to="'/requests/'+$route.params.id+'/requests'" class="btn btn-secondary mt-1 mb-1">-->
      <!--            <span class="nav-link-text">{{ $t("Requests") }}</span>-->
      <!--          </router-link>-->
      <!--        </div>-->
      <!--      </div>-->
<!--      <router-view :request-data="requestData"></router-view>-->
      <div class="row">
        <div class="col-md-8">
        <request-details-card :request-data="requestData" @get-request="getRequest"></request-details-card>
          <div v-if="requestData.serviceType === 'service'" class=" col-md-12">
            <card shadow class="mt-4">
              <template #header>
                <div class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-md-4 text-start">
                      <h5 class="mb-0">{{ $t("Services") }}</h5>
                    </div>
                  </div>
                </div>
              </template>


              <!--      <div class="fw-bolder text-uppercase text-muted mt-4 text-start">Details</div>-->
              <!--      <hr class="m-0">-->
              <div class="pl-lg-4 text-start table-responsive">
                <table class="table">
                  <tr>
                    <th class="text-start" style="border-top: none">No</th>
                    <th class="text-start" style="border-top: none">Name</th>
                  </tr>
                  <tr v-for="(item, index) in requestData.services" :key="index" class="list-unstyled text-start">
                    <td>{{ index+1 }}</td>
                    <th>{{ item.name.en }}</th>
                  </tr>
                </table>
              </div>
            </card>
          </div>
        </div>
        <div class=" col-md-4">
          <card shadow class="">
            <template #header>
              <div class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8 text-start">
                    <h5 class="mb-0">{{ $t("Client address") }}</h5>
                  </div>
</div>
              </div>
            </template>
            <client-address v-if="privateRequestData && privateRequestData.hasOwnProperty('clientDetails')" :client-data="privateRequestData.clientDetails"></client-address>
          </card>

          <card shadow class="mt-3">
            <template #header>
              <div class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8 text-start">
                    <h5 class="mb-0">{{ $t("Price overview") }}</h5>
                  </div>
</div>
              </div>
            </template>
            <request-pricing-card v-if="requestData.hasOwnProperty('cost')" :single-line="true" :cost="requestData.cost"></request-pricing-card>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getStatusClass} from "@/helpers/common"
import RequestDetailsCard from "@/views/Requests/RequestDetailsCard"
import RequestPricingCard from "@/views/Cards/RequestPricingCard"
import ClientAddress from "@/views/Cards/ClientAddressCard.vue"

export default {
  name: "SystemRequestView",
  components: {ClientAddress, RequestPricingCard, RequestDetailsCard},
  data() {
    return {
      today: new Date(),
      nav: null,
      privateRequestData: null,
      requestData: {
        mStartTime: null,
      },
      address: {}
    }
  },
  async mounted() {
    // var self = this;
    await this.getRequest()
    await this.getPrivateRequest()
  },
  methods: {
    getStatusClass,
    async getPrivateRequest(){
      await this.$store
          .dispatch("fetchPrivateRequest", this.$route.params.id)
          .then((data) => {
            console.log("private request data", data)
            this.privateRequestData = data
          })
    },
    async getRequest() {
      let self = this
      await this.$store
          .dispatch("fetchRequest", this.$route.params.id)
          .then((data) => {
            console.log("data", data)
            self.requestData = data
          })
    },
  },
}
</script>

<style scoped>

</style>